import React, { FC } from 'react';
import styles from './DeviantArtIcon.scss';

export const DeviantArtIcon: FC = () => <div className={styles.deviantArtIcon} />;
